import { render } from "./SharedProfileData.vue?vue&type=template&id=26612e0f"
import script from "./SharedProfileData.vue?vue&type=script&lang=js"
export * from "./SharedProfileData.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__